import { getAppLayoutWithCart } from '@components/layout/app-layout/app-layout';
import LayoutSafeArea from '@components/layout/layout-safe-area/layout-safe-area';
import { v2_FallbackProvider as FallbackProvider } from '@crocodille/common';
import styles from './about-layout.module.scss';

const AboutLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <LayoutSafeArea innerClassName={styles.content}>{children}</LayoutSafeArea>
  );
};

export function getAboutLayout(
  children: React.ReactNode,
  fallback: Record<string, unknown>,
) {
  return getAppLayoutWithCart(
    <FallbackProvider fallback={fallback}>
      <AboutLayout>{children}</AboutLayout>
    </FallbackProvider>,
  );
}

export default AboutLayout;
